import { Module, MutationTree, ActionTree, GetterTree } from "vuex"
import { RootState } from "@/store"

export interface AppLayoutState {
    isMobile: boolean
    isLandscapeMobile: boolean
    resizeHandler: () => void
    contentRef: HTMLElement | null
}

const state: AppLayoutState = {
    isMobile: false,
    isLandscapeMobile: false,
    resizeHandler: () => {},
    contentRef: null,
}

const mutations: MutationTree<AppLayoutState> = {
    setIsMobile(state, isMobile: boolean) {
        state.isMobile = isMobile
    },
    setIsLandscapeMobile(state, isLandscapeMobile: boolean) {
        state.isLandscapeMobile = isLandscapeMobile
    },
    setResizeHandler(state, handler: () => void) {
        state.resizeHandler = handler
    },
    setContentRef(state, contentRef: HTMLElement) {
        state.contentRef = contentRef
    },
}

const actions: ActionTree<AppLayoutState, RootState> = {
    checkIfMobile({ commit }) {
        const isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent,
        )

        commit("setIsMobile", isMobile)

        const isLandscape = window.innerWidth > window.innerHeight
        const isLandscapeMobile = isMobile && isLandscape

        commit("setIsLandscapeMobile", isLandscapeMobile)
    },
    startListening({ dispatch, commit, state }) {
        dispatch("checkIfMobile")

        const resizeHandler = () => {
            dispatch("checkIfMobile")
        }

        commit("setResizeHandler", resizeHandler)
        window.addEventListener("resize", state.resizeHandler)
        window.addEventListener("orientationchange", state.resizeHandler)
    },
    stopListening({ state }) {
        window.removeEventListener("resize", state.resizeHandler)
        window.removeEventListener("orientationchange", state.resizeHandler)
    },
}

const getters: GetterTree<AppLayoutState, RootState> = {
    isMobile: (state) => state.isMobile,
    isLandscapeMobile: (state) => state.isLandscapeMobile,
    contentRef: (state) => state.contentRef,
}

const appLayoutModule: Module<AppLayoutState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

export default appLayoutModule
